import { render, staticRenderFns } from "./OrderToStock.vue?vue&type=template&id=76d83bfe"
import script from "./OrderToStock.vue?vue&type=script&lang=js"
export * from "./OrderToStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports